/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ProductionInfoView,
    ProductionInfoViewFromJSON,
    ProductionInfoViewFromJSONTyped,
    ProductionInfoViewToJSON,
    ProductionSetObjectType,
    ProductionSetObjectTypeFromJSON,
    ProductionSetObjectTypeFromJSONTyped,
    ProductionSetObjectTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProductionSetView
 */
export interface ProductionSetView {
    /**
     * 
     * @type {string}
     * @memberof ProductionSetView
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionSetView
     */
    batesNumberPrefix?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductionSetView
     */
    batesNumberStart?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ProductionSetView
     */
    downloadedDate?: Date | null;
    /**
     * 
     * @type {ProductionInfoView}
     * @memberof ProductionSetView
     */
    productionInfo?: ProductionInfoView;
    /**
     * 
     * @type {string}
     * @memberof ProductionSetView
     */
    documentId?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionSetView
     */
    caseId?: string;
    /**
     * 
     * @type {Date}
     * @memberof ProductionSetView
     */
    createdDate?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof ProductionSetView
     */
    isArchived?: boolean;
    /**
     * 
     * @type {ProductionSetObjectType}
     * @memberof ProductionSetView
     */
    objectType?: ProductionSetObjectType;
}

export function ProductionSetViewFromJSON(json: any): ProductionSetView {
    return ProductionSetViewFromJSONTyped(json, false);
}

export function ProductionSetViewFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductionSetView {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'batesNumberPrefix': !exists(json, 'batesNumberPrefix') ? undefined : json['batesNumberPrefix'],
        'batesNumberStart': !exists(json, 'batesNumberStart') ? undefined : json['batesNumberStart'],
        'downloadedDate': !exists(json, 'downloadedDate') ? undefined : (json['downloadedDate'] === null ? null : new Date(json['downloadedDate'])),
        'productionInfo': !exists(json, 'productionInfo') ? undefined : ProductionInfoViewFromJSON(json['productionInfo']),
        'documentId': !exists(json, 'documentId') ? undefined : json['documentId'],
        'caseId': !exists(json, 'caseId') ? undefined : json['caseId'],
        'createdDate': !exists(json, 'createdDate') ? undefined : (new Date(json['createdDate'])),
        'isArchived': !exists(json, 'isArchived') ? undefined : json['isArchived'],
        'objectType': !exists(json, 'objectType') ? undefined : ProductionSetObjectTypeFromJSON(json['objectType']),
    };
}

export function ProductionSetViewToJSON(value?: ProductionSetView | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'batesNumberPrefix': value.batesNumberPrefix,
        'batesNumberStart': value.batesNumberStart,
        'downloadedDate': value.downloadedDate === undefined ? undefined : (value.downloadedDate === null ? null : value.downloadedDate.toISOString()),
        'productionInfo': ProductionInfoViewToJSON(value.productionInfo),
        'documentId': value.documentId,
        'caseId': value.caseId,
        'createdDate': value.createdDate === undefined ? undefined : (value.createdDate.toISOString()),
        'isArchived': value.isArchived,
        'objectType': ProductionSetObjectTypeToJSON(value.objectType),
    };
}


